import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import Swiper from 'swiper';
import { Account } from '@jaimo-solutions-gmbh/platform-services-module';
import { StoriesService } from '../../services/stories.service';

@Component({
  selector: 'app-stories',
  templateUrl: './stories.component.html',
  styleUrls: ['./stories.component.scss'],
})
export class StoriesComponent implements OnInit {
  DISPLAY_TIME = 10_000;
  swiper: Swiper;
  currentIndex = 0;
  accounts: Account[] = [];
  account: Account;
  stories;
  isLoading = false;
  muted: boolean = true;

  constructor(
    private modalCtrl: ModalController,
    private storiesService: StoriesService
  ) {}

  ngOnInit(): void {
    this.load(this.account.handle);
  }

  load(handle: string) {
    this.isLoading = true;
    this.storiesService.getStories(handle).then((story: any) => {
      this.stories = story;
      this.isLoading = false;
    });
  }

  startProgress(index) {
    const bars: HTMLDivElement[] = Array.from(
      document.getElementsByClassName('progress-bar-fill')
    ) as HTMLDivElement[];

    bars[index].style.animation = `fill ${
      this.stories.stories[index].duration || '10'
    }s linear forwards`;
    bars[index].onanimationend = () => this.next({ muted: this.muted });
  }

  start() {
    this.startProgress(this.currentIndex);
  }

  onSwiper(swiper) {
    this.swiper = swiper;
    this.swiper.allowTouchMove = false;
  }

  setBars(index) {
    const bars: HTMLDivElement[] = Array.from(
      document.getElementsByClassName('progress-bar-fill')
    ) as HTMLDivElement[];

    for (let i = 0; i < bars.length; i++) {
      const bar = bars[i];
      if (i < index) {
        bar.style.animation = 'none';
        bar.style.width = '100%';
      } else {
        bar.style.width = '0%';
        bar.style.animation = 'none';
      }
    }
  }

  resetProgress() {
    const bars: HTMLDivElement[] = Array.from(
      document.getElementsByClassName('progress-bar-fill')
    ) as HTMLDivElement[];
    bars[this.currentIndex].style.animation = 'none';
  }

  close() {
    this.modalCtrl.dismiss();
  }

  next(data) {
    this.muted = data.muted;
    this.swiper.slideNext(0);
    const newIndex = Math.min(
      this.currentIndex + 1,
      this.stories.stories.length - 1
    );

    if (newIndex === this.currentIndex) {
      this.setBars(this.currentIndex + 1);
    } else {
      this.currentIndex = newIndex;
      this.setBars(this.currentIndex);
    }
  }

  prev(data) {
    this.muted = data.muted;
    this.swiper.slidePrev(0);
    const newIndex = Math.max(this.currentIndex - 1, 0);
    if (newIndex === this.currentIndex) {
      this.resetProgress();
    } else {
      this.currentIndex = newIndex;
    }
    this.setBars(this.currentIndex);
  }
}
